module.exports = __webpack_public_path__ + "static/media/emerg.b8b53600.jpg";